import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Form } from "../../../components/ui/form";

import { Button } from "../../../components/ui/button";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../components/spinner.components";
import { useCreateBrandHttp } from "../../../hooks/http/brand/brands/create-brand.brand.http";
import { useToast } from "../../../hooks/use-toast";
import { FormInput } from "../../../components/form-components/form-input.components";
import { handleHttpError } from "../../../utils/utils";
import { useDashboardConfigCommonHttp } from "../../../hooks/http/common/users/dashboard-config.common.http";
import { useUserStore } from "../../../store/user.store";

const FormSchema = z.object({
	companyName: z.string().min(2),
});

const CreateBrandCommonPartial: React.FunctionComponent = () => {
	const form = useForm<z.infer<typeof FormSchema>>({
		resolver: zodResolver(FormSchema),
		defaultValues: {
			companyName: "",
		},
	});

	const { toast } = useToast();

	const navigate = useNavigate();
	const { fetching: creatingBrand, execute: createBrandHttp } =
		useCreateBrandHttp();
	const { execute: fetchConfig } = useDashboardConfigCommonHttp();

	const { setUser, logout } = useUserStore();

	async function getConfig() {
		const response = await fetchConfig({ body: null });
		if (!response.success) {
			if (response.error.logout) {
				await logout();
			}
			return handleHttpError(response, toast);
		}
		setUser(response.data.user);
		if (response.data.brands.length === 0) {
			return;
		}
		
	}

	async function onSubmit(data: z.infer<typeof FormSchema>) {
		console.log(data);
		const response = await createBrandHttp({
			body: {
				name: data.companyName,
			},
		});
		if (!response.success) {
			return handleHttpError(response, toast);
		}
		await getConfig();
		navigate("/");
	}

	return (
		<div className="flex flex-col justify-center gap-10 w-full h-full font-gliroy_regular">
			<h1 className="font-gliroy_medium font-semibold text-3xl">
				Enter your brand details
			</h1>
			<Form {...form}>
				<form
					onSubmit={form.handleSubmit(onSubmit)}
					className="space-y-8 w-full"
				>
					<FormInput
						form={form}
						name="companyName"
						label="Company name"
						placeholder="Enter your company / brand name"
						min={2}
						type="text"
					/>

					<Button
						className="border-primarybuttonborder bg-[--primary-button-bg] py-8 border w-full font-semibold text-lg text-primarybuttontext"
						type="submit"
					>
						{creatingBrand ? <Spinner /> : "Sign up"}
					</Button>
				</form>
			</Form>
		</div>
	);
};

export default CreateBrandCommonPartial;
